"use strict";

var $ = require("jquery");
var uuid = require("./uuidMIT");

var ResetForgotPassword = require("./change-forgotten-password");
var InvalidTokenResetPassword = require("./invalidToken-forgot-password");
var MAIN_TEMPLATE = require("../html/ResetPassword.html");
var INVALID_TOKEN_TEMPLATE = "";
var RESET_PASSWORD_TEMPLATE = "";
var CHANGE_PASSWORD_COMMON = "";


require("../style/general.scss");
require("../style/uim-widget.scss");
var common = require("./common");
var templatesText = require("../json/TemplatesText.json");

var OPTIONAL_FIELDS = [{
    selector: ".ie789-only",
    configKey: "showLabels"
}];

function UimResetPasswordWidget(params) {
    common.validateParams(params);
    this.successCallback = params.configuration.success || window.morningstar.uim.success;
    this.errorCallback = params.configuration.error || window.morningstar.uim.error;
    this.apigeeKey = params.configuration.apigeeKey;
    this.token = params.configuration.token;
    this.passwordPlaceholder = params.configuration.passwordPlaceholder;
    this.passwordConfirmationPlaceholder = params.configuration.passwordConfirmationPlaceholder;
    this.environment = params.configuration.environment;
    this.apiUrl = common.API_ENVIRONMENTS[this.environment] + '/passwords/reset-requests';
    this.element = params.element;
    this.locale = common.getUrlParameter("culture");
}

UimResetPasswordWidget.prototype.init = function () {
    var self = this,
        languagesSupport = ["it", "es", "nl", "fr", "de", "se", "nb", "fi", "da", "th", "en","it-it", "es-cl","es-mx", "nl-be","nl-nl", "fr-fr","fr-ch", "de-de","de-at","de-ch", "se-se", "nb-no", "fi-fi", "da-dk", "th-th", "en-us","en-gb","en-in","en-no","en-ch","en-ca"],
        language = common.getUserPreferredLocale(this.locale, languagesSupport),
        handleBarTemplates = window.morningstar.uim.templates,
        // Select the widget data using language locale
        widgetText = templatesText[language];

    INVALID_TOKEN_TEMPLATE = handleBarTemplates.InvalidTokenForgotPassword(widgetText.invalidToken);
    RESET_PASSWORD_TEMPLATE = handleBarTemplates.ChangeForgottenPassword(widgetText.resetPassword);
    CHANGE_PASSWORD_COMMON = handleBarTemplates.CommonSetPassword(widgetText.commonPassword);

    this.element.append(MAIN_TEMPLATE);
    this.resetForgotPasswordParent = this.element.find(".uim-reset-password");
    this.resetForgotPasswordParent.append(RESET_PASSWORD_TEMPLATE);
    this.resetForgotPasswordParent.find("div#uim-uChangePassword-input").append(CHANGE_PASSWORD_COMMON);
    common.showElement(this.resetForgotPasswordParent.find("div#showPasswordRequirements"));

    // default ResetForgotPassword to be hidden
    this.resetForgotPasswordParent.hide();

    this.invalidTokenParent = this.element.find(".uim-invalid-token");
    this.invalidTokenParent.append(INVALID_TOKEN_TEMPLATE);

    // default invalid token page to be hidden
    this.invalidTokenParent.hide();

    for (var index = 0; index < OPTIONAL_FIELDS.length; index++) {
        var field = OPTIONAL_FIELDS[index];

        var showField = this[field.configKey];

        if (showField === false || showField === undefined) {
            common.hideElement(this.element.find(field.selector));
        }
    }

    var requestId = uuid();

    if(this.token !== null && this.token !== "" && this.token !== undefined && this.token !== true){
        $.ajax({
            method: "GET",
            url: this.apiUrl + "/" + this.token,
            headers : {
                ApiKey : this.apigeeKey,
                "X-API-RequestId": requestId
            },
            dataType: 'json',
            contentType: "application/json"
        }).success(function(data, status) {
            self.successCallback(data, status);
            self.resetForgotPasswordParent.show();
            self.invalidTokenParent.hide();

            var emailAddress = data.data.attributes.emailAddress;

            var resetForgotPassword = new ResetForgotPassword({
                resetPasswordWidgetInstance: self,
                email: emailAddress,
                language: language,
                token:self.token,
                environment: self.environment,
                apigeeKey: self.apigeeKey,
                passwordPlaceholder: self.passwordPlaceholder,
                confirmPasswordPlaceholder: self.passwordConfirmationPlaceholder
            });
            return resetForgotPassword.init(requestId);

        }).error(function (response, status) {
            self.errorCallback(new Error("Expired password link"), response.status);
            self.validateToken(language, requestId);
        });
    } else {
        self.validateToken(language, requestId);
    }
};

UimResetPasswordWidget.prototype.validateToken = function (language, requestId) {
    var self = this;
    self.resetForgotPasswordParent.hide();
    self.invalidTokenParent.show();

    var invalidTokenPage = new InvalidTokenResetPassword({
        resetPasswordWidgetInstance: self,
        language: language,
        environment: self.environment,
        apigeeKey: self.apigeeKey
    });
    return invalidTokenPage.init(requestId);
};

module.exports = {
    createComponent: function (params) {
        var uimWidget = new UimResetPasswordWidget(params);
        uimWidget.init();

        return {
            setProperty: function () {},
            destroy: function () {
                params.element.children().remove();
            }
        };
    }
};



//////////////////
// WEBPACK FOOTER
// ./components/ui-widgets/src/js/reset-password.js
// module id = 19
// module chunks = 0